import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';

import {
    Avatar,
    Icon,
    Tooltip,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    IconButton,
    Grid,
    colors,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@material-ui/core';


import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Add from '@material-ui/icons/AddCircleOutline';
import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';

import { FaWaveSquare } from "react-icons/fa";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        margin: 15
    },
    btnadd: {
        marginBottom: 10
    }
}));

const Schedules = ({ item, open, schedules, closeSchedules, openSchedule }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Programações de Processos
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({})
                            }
                            onSubmit={(values, formik) => {
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>

                                    <TableContainer component={PerfectScrollbar}>

                                        <Table stickyHeader size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        Nome
                                                    </TableCell>
                                                    <TableCell>
                                                        Descrição
                                                    </TableCell>
                                                    <TableCell>
                                                        Reinicio Automático em
                                                    </TableCell>
                                                    <TableCell>
                                                        Última Execução
                                                    </TableCell>
                                                    <TableCell>
                                                        Próxima Execução
                                                    </TableCell>
                                                    <TableCell>
                                                        Habilitado
                                                    </TableCell>
                                                    <TableCell>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(schedules.length > 0) ?
                                                    (schedules.map((schedule, index) => (
                                                        <TableRow hover key={schedule.id} >
                                                            <TableCell>
                                                                <Box alignItems="center" display="flex">
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={AccessAlarmsIcon} style={{ color: colors.blue[400] }} ></Icon>}
                                                                    </Avatar>
                                                                    {schedule.name}
                                                                </Box>
                                                            </TableCell>

                                                            <TableCell>
                                                                {schedule.description}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(schedule.automaticRestart ? (schedule.defaultInactivityOverflow + ' min.') : (''))}
                                                            </TableCell>

                                                            <TableCell>
                                                                {moment(schedule.lastInactivityCheck).format('DD/MM/YYYY HH:mm:ss')}
                                                            </TableCell>

                                                            <TableCell>
                                                                {moment(schedule.nextInactivityCheck).format('DD/MM/YYYY HH:mm:ss')}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(schedule.enabled ? 'Sim' : 'Não')}
                                                            </TableCell>

                                                            <TableCell >
                                                                <Tooltip title="Editar Processo Programado">
                                                                    <IconButton
                                                                        color="secondary"
                                                                        className={classes.btntreatment}
                                                                        children={<EditRoundedIcon />}
                                                                        onClick={() => { openSchedule(schedule) }}
                                                                        size="medium">
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>

                                                        </TableRow>
                                                    ))) : (
                                                        <TableRow >
                                                            <TableCell colSpan={6} >Nenhum Processo Programado para o Equipamento</TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>


                                    <Box my={1}></Box>
                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeSchedules() }}>
                                                    Fechar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Schedules;
